import { type FC } from 'react';
import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';

// screen
import StatCard from 'modules/dashboard/components/StatCard';
import { percentOf } from 'modules/dashboard/helpers/accessStats';
import type { AccessStatisticsResponse } from 'modules/dashboard/types';

interface Props {
  data?: AccessStatisticsResponse | null;
}

/**
 * Tầng 2: tổng lượt (không có %) + 4 nhóm vai trò kèm badge %.
 * % tính ở FE = lượt của nhóm / tổng lượt — API cố tình không trả sẵn.
 */
const AccessVisitCards: FC<Props> = ({ data }) => {
  const { formatMessage } = useIntl();
  const total = data?.total_visits ?? null;

  const groups: { id: 'cqcq' | 'cqql' | 'client' | 'guest'; label: string }[] = [
    { id: 'cqcq', label: formatMessage({ id: 'dashboard.access.cqcq' }) },
    { id: 'cqql', label: formatMessage({ id: 'dashboard.access.cqql' }) },
    { id: 'client', label: formatMessage({ id: 'dashboard.access.client' }) },
    { id: 'guest', label: formatMessage({ id: 'dashboard.access.guest' }) },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 2,
      }}
    >
      <StatCard label={formatMessage({ id: 'dashboard.access.totalVisits' })} numerator={total} />
      {groups.map((group) => (
        <StatCard
          key={group.id}
          label={group.label}
          // M4: by_role_group có thể chưa tồn tại (data rỗng/lỗi) — thiếu dấu `?` ở đây từng ném
          // TypeError khi data?.by_role_group là undefined nhưng vẫn cố index vào nó.
          numerator={data?.by_role_group?.[group.id] ?? null}
          percent={percentOf(data?.by_role_group?.[group.id], total)}
        />
      ))}
    </Box>
  );
};

export default AccessVisitCards;
